module.exports = __webpack_public_path__ + "img/about.620679a7.png";